// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PartnerDetails_wrapper__1RfPH","wrapper__title":"PartnerDetails_wrapper__title__2XF9x"};